declare namespace $ {

	type $mol_string__value_bog_theme_picker_1 = $mol_type_enforce<
		ReturnType< $bog_theme_picker['query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_theme_picker_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_list__rows_bog_theme_picker_3 = $mol_type_enforce<
		ReturnType< $bog_theme_picker['theme_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_bog_theme_picker_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $bog_theme_picker_row__theme_name_bog_theme_picker_5 = $mol_type_enforce<
		ReturnType< $bog_theme_picker['theme_name'] >
		,
		ReturnType< $bog_theme_picker_row['theme_name'] >
	>
	type $bog_theme_picker_row__focused_bog_theme_picker_6 = $mol_type_enforce<
		ReturnType< $bog_theme_picker['theme_focused'] >
		,
		ReturnType< $bog_theme_picker_row['focused'] >
	>
	type $bog_theme_picker_row__click_bog_theme_picker_7 = $mol_type_enforce<
		ReturnType< $bog_theme_picker['theme_select'] >
		,
		ReturnType< $bog_theme_picker_row['click'] >
	>
	type $bog_theme_picker_row__hover_bog_theme_picker_8 = $mol_type_enforce<
		ReturnType< $bog_theme_picker['theme_hover'] >
		,
		ReturnType< $bog_theme_picker_row['hover'] >
	>
	export class $bog_theme_picker extends $mol_scroll {
		theme_name( id: any): string
		theme_focused( id: any): boolean
		theme_select( id: any, next?: any ): any
		theme_hover( id: any, next?: any ): any
		Search( ): $mol_string
		theme_rows( ): readonly(any)[]
		Theme_list( ): $mol_list
		Content( ): $mol_list
		key_down( next?: any ): any
		theme_auto( ): $bog_theme_auto
		close( next?: any ): any
		query( next?: string ): string
		focused_index( next?: number ): number
		Theme_row( id: any): $bog_theme_picker_row
		sub( ): readonly(any)[]
		event( ): ({ 
			keydown( next?: ReturnType< $bog_theme_picker['key_down'] > ): ReturnType< $bog_theme_picker['key_down'] >,
		})  & ReturnType< $mol_scroll['event'] >
	}
	
}

//# sourceMappingURL=picker.view.tree.d.ts.map